<template>
  <div class="async-fallback">
    <div class="image-wrapper">
      <img :src="require('@/assets/onboarding/big-icon-eclipse.svg')" class="sun-image">
    </div>
    <div class="title">נראה שהחיבור לוקח יותר זמן מהרגיל</div>
    <div class="description">
      המערכת תמשיך לנסות אבל לא צריך להמתין ואפשר לסגור את החלון.
      <span class="bold">אנחנו נעדכן אותך ב-WhatsApp</span> בהתקדמות ונמשיך בהרשמה.</div>
  </div>
</template>

<script>

import Segment from '../../Segment';

export default {
  name: 'AsyncFallback',
  async created() {
    Segment.trackUserGot('AsyncFallbackEnteredOB', { sourceName: this.source.sourceName });
  },
  components: {
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .async-fallback {
    text-align: center;
    @include responsive-padding;

    .image-wrapper {
      width: 100%;
      margin: 60px 0 40px;

      .sun-image {
        width: 120px;
      }
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      font-family: SimplerPro;
      margin-bottom: 20px;
    }

    .description {
      font-size: 16px;
      font-family: SimplerPro;
      line-height: 1.5;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>
